export const INCLUSION = "inclusions";

export const TIER = {
  "Tier I": "Basic",
  "Tier II": "Classic",
  "Tier III": "Comfort",
};

export const TENANT_HOUSING_TEXT_MAP = {
  "001Ql000008vlP2IAI":
    "We know that comfort and safety are top priorities when it comes to housing. That's why API's Visited and Verified™ brand means that every one of our housing options has been inspected by API personnel and meets our standards for quality, security and convenience.",
  generic:
    "Your home away from home matters. Below, you’ll find details about the housing available for this program. The housing is designed to help you settle in comfortably and focus on making the most of your experience.",
};
